import { useState, useEffect } from "react";
import ReferralEventsTable from "../components/dashboard/ReferralEventsTable";
import CommissionsChart from "../components/dashboard/CommissionsChart";
import { PuffLoader } from "react-spinners";

const ReferralPage = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadEvents = async () => {
      try {
      } catch (error) {
        console.error("Error al cargar eventos:", error);
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 700);
      }
    };

    loadEvents();
  }, []);

  return (
    <div className="referral-page">
      <header className="page-header">
        <h1>Gestión de Referidos</h1>
        <p>Administra las estadísticas de tus referidos</p>
      </header>

      {loading ? (
        <div className="loader-container">
          <PuffLoader
            color="#009ee3"
            loading={true}
            size={60}
            margin={2}
            speedMultiplier={4}
          />
        </div>
      ) : (
        <div className="referral-page__content">
          <CommissionsChart />
          <ReferralEventsTable />
        </div>
      )}
    </div>
  );
};

export default ReferralPage;
